// Keep Froala focus calls from scrolling the page.
const FROALA_FOCUS_SCOPE_SELECTOR = '.fr-box, .fr-popup';

export const resolveFocusOptions = (
    element: HTMLElement,
    options?: FocusOptions
): FocusOptions | undefined => {
    const isFroalaInternal = !!element.closest?.(FROALA_FOCUS_SCOPE_SELECTOR);

    if (options?.preventScroll || !isFroalaInternal) {
        return options;
    }

    return { ...options, preventScroll: true };
};

let froalaFocusScrollGuardInstalled = false;

export const installFroalaFocusScrollGuard = () => {
    if (froalaFocusScrollGuardInstalled || typeof HTMLElement === 'undefined') {
        return;
    }
    froalaFocusScrollGuardInstalled = true;

    const originalFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (
        this: HTMLElement,
        options?: FocusOptions
    ) {
        originalFocus.call(this, resolveFocusOptions(this, options));
    };
};
